// blog data

export const Blogs = [
  {
    id: 1,
    name: 'AI taking over the world',
    tags: ['technology', 'ai', 'machine learning'],
    date: '24 Dec, 2023',
    imgSrc:
      'https://keshavwrites.netlify.app/_next/image?url=https%3A%2F%2Ffirebasestorage.googleapis.com%2Fv0%2Fb%2Fblog-aa0a6.appspot.com%2Fo%2F1703414125960Screenshot%25202023-06-29%2520165615.png%3Falt%3Dmedia%26token%3D3b5962ec-8442-4e1f-88c0-1bcfa639479f&w=1920&q=75',
    link: 'https://keshavwrites.netlify.app/posts/ai-taking-over-the-world',
  },
  {
    id: 2,
    name: 'Roadmap for Learning Fullstack Web Development',
    tags: ['fullstack', 'web development', 'learning'],
    date: '26 Dec, 2023',
    imgSrc:
      'https://keshavwrites.netlify.app/_next/image?url=https%3A%2F%2Ffirebasestorage.googleapis.com%2Fv0%2Fb%2Fblog-aa0a6.appspot.com%2Fo%2F1703607258253fullstack.jpeg%3Falt%3Dmedia%26token%3Deeb53134-7efd-44a8-90f9-c7d63bfb6fe4&w=1920&q=75',
    link: 'https://keshavwrites.netlify.app/posts/roadmap-for-learning-fullstack-web-development',
  },
  {
    id: 3,
    name: 'Unraveling the Mysteries of Ancient Cryptography',
    tags: ['cryptography', 'history', 'ancient'],
    date: '31 Dec, 2023',
    imgSrc:
      'https://keshavwrites.netlify.app/_next/image?url=https%3A%2F%2Ffirebasestorage.googleapis.com%2Fv0%2Fb%2Fblog-aa0a6.appspot.com%2Fo%2F1704050203452crypt.jpg%3Falt%3Dmedia%26token%3De5158f73-ea3b-41fe-97bc-85f57a45a9a4&w=1920&q=75',
    link: 'https://keshavwrites.netlify.app/posts/unraveling-the-mysteries-of-ancient-cryptography',
  },
  {
    id: 4,
    name: 'The Era of 1-Bit LLMs: Research Paper Decoded',
    tags: ['research', '1-bit llms', 'machine learning'],
    date: '25 May, 2024',
    imgSrc:
      'https://keshavwrites.netlify.app/_next/image?url=https%3A%2F%2Ffirebasestorage.googleapis.com%2Fv0%2Fb%2Fblog-aa0a6.appspot.com%2Fo%2F1716666503994_Designer(1).png%3Falt%3Dmedia%26token%3Db9bf9b5c-1b9b-4ae7-9026-7ca4b4ced248&w=1920&q=75',
    link: 'https://keshavwrites.netlify.app/posts/the-era-of-1-bit-llms-research-paper-decoded',
  },
  {
    id: 5,
    name: 'Dissecting MORA: High-Rank Updating for Parameter-Efficient Fine-Tuning',
    tags: ['machine learning', 'fine-tuning', 'MORA'],
    date: '30 May, 2024',
    imgSrc:
      'https://keshavwrites.netlify.app/_next/image?url=https%3A%2F%2Ffirebasestorage.googleapis.com%2Fv0%2Fb%2Fblog-aa0a6.appspot.com%2Fo%2F1717099416461_Screenshot_31-5-2024_1331_arxiv.org.jpeg%3Falt%3Dmedia%26token%3D034dc738-e11e-4a64-b7e4-073e731c7b33&w=1920&q=75',
    link: 'https://keshavwrites.netlify.app/posts/dissecting-mora-high-rank-updating-for-parameter-efficient-fine-tuning',
  },
];
